import { getJSONFromScript } from 'lib/server_params'

import { SCRIPT_IDS } from 'shared/shared_consts'

export function getStore() {
  return getJSONFromScript(SCRIPT_IDS.STORE)
}
